

export const veoFeatures = {
    title: 'Core Features of AI Video Generation',
    subtitle:
      'Advanced models provide cinematic video capabilities: keyframe control, longer duration, multi‑image references, and native audio.',
    items: [
      {
        num: '01',
        title: 'Keyframe Control - Start and End Frame Precision',
        body:
          'Precisely control the start and end of your AI video with keyframe mode. Create smooth cinematic transitions and maintain narrative flow.'
      },
      {
        num: '02',
        title: 'Multi‑Image References',
        body:
          'Guide visual style with multiple reference images—characters, lighting, color tone—ensuring consistent aesthetics across shots.'
      },
      {
        num: '03',
        title: 'Native Audio and Enhanced Sound Effects',
        body:
          'Automatically generated dialogue, ambient sounds, and action‑synchronized audio that perfectly syncs with visuals.'
      },
      {
        num: '04',
        title: 'Extend Video Duration Beyond 8 Seconds',
        body:
          'Break through the 8‑second limit. Continue action and narrative naturally for longer, dynamic videos.'
      }
    ]
  };
